export default __webpack_public_path__ + "static/media/redflower.4cf0d572.png";